<div class="logo-admin-container">
    <!-- Header -->
    <div class="logo-header">
        <div class="header-content">
            <h1 class="logo-title">
                <fa-icon [icon]="icons.faImage" class="title-icon"></fa-icon>
                Logo Management
            </h1>
            <p class="logo-subtitle">Upload and manage your board's logo</p>
        </div>
    </div>

    <!-- Main Content -->
    <div class="logo-content">
        <!-- Upload Section -->
        <div class="upload-section">
            <div class="upload-header">
                <h2 class="section-title">
                    <fa-icon [icon]="icons.faCloudUploadAlt" class="section-icon"></fa-icon>
                    Upload Logo
                </h2>
                <p class="section-description">Add a new logo to your board</p>
            </div>

            <div class="upload-area">
                <div class="upload-input-wrapper">
                    <input 
                        type="file" 
                        id="filePicker" 
                        class="file-input"
                        (change)="selectFile($event)"
                        accept="image/*">
                    <label for="filePicker" class="file-input-label">
                        <div class="file-input-content">
                            <div class="upload-icon">📁</div>
                            <p class="upload-text">
                                <span class="upload-highlight" *ngIf="!selectedFile">Click to select or drag a file here</span>
                                <span *ngIf="selectedFile" class="file-selected">{{ selectedFile.name }}</span>
                            </p>
                            <p class="upload-hint">PNG, JPG up to 10MB</p>
                        </div>
                    </label>
                </div>

                <!-- Upload Status -->
                <div *ngIf="uploadStatus" class="upload-status">
                    <div class="status-content">
                        <span class="status-label">{{ uploadStatus }}</span>
                        <span class="upload-progress">{{ uploadPercent }}</span>
                    </div>
                    <div class="progress-bar-container">
                        <div class="progress-bar" [ngStyle]="{'width': uploadPercent}"></div>
                    </div>
                </div>

                <!-- Upload Button -->
                <button 
                    class="btn btn-primary"
                    (click)="uploadFile()"
                    [disabled]="!selectedFile || uploadStatus">
                    <fa-icon [icon]="icons.faUpload" class="btn-icon"></fa-icon>
                    <span class="btn-text">Upload Logo</span>
                </button>
            </div>
        </div>

        <!-- Logo Gallery Section -->
        <div class="gallery-section" *ngIf="logos.length > 0">
            <div class="gallery-header">
                <h2 class="section-title">
                    <fa-icon [icon]="icons.faImages" class="section-icon"></fa-icon>
                    Your Logos
                </h2>
                <p class="section-description">Select which logo to use or remove ones you don't need</p>
            </div>

            <div class="logo-gallery">
                <!-- Logo Items -->
                <div 
                    *ngFor="let logo of logos" 
                    class="logo-item"
                    [class.selected]="logo.url==selectedLogo?.url">
                    <div class="logo-image-wrapper" (click)="selectLogo(logo)">
                        <img [src]="logo.url" class="logo-image" />
                        <div class="logo-overlay">
                            <button 
                                class="btn-delete"
                                title="Delete Logo"
                                (click)="deleteLogo(logo); $event.stopPropagation()">
                                <fa-icon [icon]="icons.faTrash"></fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="logo-label">
                        <span *ngIf="logo.url==selectedLogo?.url" class="selected-badge">
                            <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                            Active Logo
                        </span>
                        <span *ngIf="logo.url!=selectedLogo?.url" class="inactive-badge">
                            Click to use
                        </span>
                    </div>
                </div>

                <!-- No Logo Option -->
                <div 
                    class="logo-item"
                    [class.selected]="!selectedLogo">
                    <div class="no-logo-wrapper" (click)="selectLogo(undefined)">
                        <div class="no-logo-content">
                            <div class="no-logo-icon">✕</div>
                            <p class="no-logo-text">No Logo</p>
                        </div>
                    </div>
                    <div class="logo-label">
                        <span *ngIf="!selectedLogo" class="selected-badge">
                            <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                            Active
                        </span>
                        <span *ngIf="selectedLogo" class="inactive-badge">
                            Click to use
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="logos.length == 0">
            <div class="empty-content">
                <div class="empty-icon">🖼️</div>
                <h3 class="empty-title">No Logos Yet</h3>
                <p class="empty-description">Upload your first logo to get started</p>
            </div>
        </div>
    </div>
</div>
